import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import type { ESBBaseError } from '@appTypes/esb/errors';
import { intl } from '@shared/localization/translate';
import toastService from '@toasts/service';

/**
 * Show toasts messages when receiving specific ESB errors
 */
export const rtkCustomToasts: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_api: MiddlewareAPI) => next => action => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (!isRejectedWithValue(action)) return next(action);

    const payload = action.payload as FetchBaseQueryError;
    const esbErrorCode = (payload.data as ESBBaseError)?.errorCode;
    const statusCode = action.payload.status;

    // SBL-5720: 403 errors
    if (
      statusCode === 403 &&
      // error could be C406, M406, etc
      esbErrorCode?.match(/^.403/)
    ) {
      toastService.error(intl.formatMessage({ id: 'shared.apiUnauthorized' }));
    }

    return next(action);
  };
